import React, { useState, useEffect, useRef } from "react";
import { rightarrow, plus } from "../../assets/Exportimageicon";
import { useNavigate, useParams } from "react-router-dom";
import {
  GoogleMap,
  LoadScript,
  DirectionsRenderer,
  Marker,
  Autocomplete,
  Polyline,
  useJsApiLoader, Circle
} from "@react-google-maps/api";
import { apiPost, apiPatch, apiGet } from "../../Services/Services.js";
import { FaSearch, FaPlus, FaGripVertical, FaRoad, FaWalking, FaStopwatch, FaFlag, FaStopwatch20, FaLine } from "react-icons/fa";
import MilestoneCard from "../../utils/exportUtils.jsx";
import {
  DndContext,
  closestCenter,
} from "@dnd-kit/core";


import {
  SortableContext,
  horizontalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import { lineString, point } from "@turf/helpers";
import nearestPointOnLine from "@turf/nearest-point-on-line";


const containerStyle = {
  width: "100%",
  height: "700px",
};

const center = {
  lat: 0,
  lng: 0,
};

export default function AddEditMission() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [points, setPoints] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);


  const start = points[0];
  const end = points[points.length - 1];



  const [formData, setFormData] = useState({
    categoryId: "",
    challengesName: "",
    shortDescription: "",
    challengeOverview: "",
    startPoint: "",
    endPoint: "",
    challengePrice: "",
    startDate: "",
    endDate: "",
    thumbnailImage: null,
    status: "",
    thumbnailPreview: "",
  });

  const [milestoneForm, setMilestoneForm] = useState({
    name: "",
    location: "",
    description: "",
    milestoneRewardPoints: 100,
    image: null,
    preview: "",
    lat: null,
    lng: null,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddingMilestone, setIsAddingMilestone] = useState(false);

  const [categories, setCategories] = useState([]);
  const [directions, setDirections] = useState(null);
  const [milestoneAutocomplete, setMilestoneAutocomplete] = useState(null);
  const [segments, setSegments] = useState([]);

  const [autocomplete, setAutocomplete] = useState(null);
  const [map, setMap] = useState(null);

  const [routeType, setRouteType] = useState("road");
  const [routeStats, setRouteStats] = useState({
    distanceKm: "",
    duration: "",
    durationSec: 0,
  });

  const [editingMilestoneId, setEditingMilestoneId] = useState(null);
  const [editingMilestone, setEditingMilestone] = useState(null);
  const [distanceUnit, setDistanceUnit] = useState("km");

  const [isMilestoneMode, setIsMilestoneMode] = useState(false);
  const [milestones, setMilestones] = useState([]);

  const [searchCircleCenter, setSearchCircleCenter] = useState(null);
  const [errors, setErrors] = useState({});

  const [challengeData, setChallengeData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const displayDistance = routeStats.distanceKm
    ? distanceUnit === "km"
      ? `${routeStats.distanceKm.toFixed(2)} km`
      : `${(routeStats.distanceKm * 0.621371).toFixed(2)} miles`
    : "--";

  const pointsRef = useRef([]);
  const routeClickLockRef = useRef(false);

  const today = new Date().toLocaleDateString("en-CA");

  useEffect(() => {
    pointsRef.current = points;
  }, [points]);



  useEffect(() => {
    getCategories();

    if (id) {
      getChallengeDetails();
    }
  }, [id]);

  useEffect(() => {
    if (
      !map ||
      !challengeData ||
      !window.google ||
      !challengeData.routePoints?.length
    ) {
      return;
    }

    let cancelled = false;

    const loadEditRoute = async () => {
      try {
        const allRoutePoints = [
          ...(challengeData.routePoints || []),
        ]
          .sort(
            (a, b) =>
              Number(a.pointOrder || 0) -
              Number(b.pointOrder || 0)
          )
          .map((routePoint) => ({
            id: routePoint.id
              ? `route-${routePoint.id}`
              : uuidv4(),

            backendId: routePoint.id,

            lat: Number(routePoint.latitude),
            lng: Number(routePoint.longitude),

            name: routePoint.title,
            address: routePoint.title,

            routeSource: routePoint.routeSource,
            routeMode: routePoint.routeMode,

            isConnector:
              routePoint.title?.startsWith(
                "__ROUTE_CONNECTOR__"
              ) || false,

            segmentType:
              routePoint.routeSource === "MANUAL"
                ? "straight"
                : routePoint.routeMode === "walking"
                  ? "trail"
                  : "road",
          }));

        if (allRoutePoints.length < 2) {
          return;
        }

        /*
         * Only real checkpoints should be displayed as numbered markers.
         * Connector points are still kept internally for route generation.
         */
        const visiblePoints = allRoutePoints.filter(
          (routePoint) => !routePoint.isConnector
        );

        if (cancelled) return;

        setPoints(visiblePoints);
        pointsRef.current = visiblePoints;

        const directionsService =
          new window.google.maps.DirectionsService();

        const loadedSegments = [];

        /*
         * The routeSource of the destination point tells us how to
         * connect the previous point to that destination point.
         */
        for (
          let index = 1;
          index < allRoutePoints.length;
          index++
        ) {
          const from = allRoutePoints[index - 1];
          const to = allRoutePoints[index];

          const routeSource =
            to.routeSource || "MANUAL";

          if (routeSource === "GOOGLE") {
            const travelMode =
              to.routeMode === "walking"
                ? window.google.maps.TravelMode.WALKING
                : window.google.maps.TravelMode.DRIVING;
            try {
              const result = await directionsService.route({
                origin: {
                  lat: from.lat,
                  lng: from.lng,
                },

                destination: {
                  lat: to.lat,
                  lng: to.lng,
                },

                travelMode,

                provideRouteAlternatives: false,
              });

              const routePath =
                result.routes[0].legs.flatMap((leg) =>
                  leg.steps.flatMap((step) =>
                    step.path.map((pathPoint) => ({
                      lat: pathPoint.lat(),
                      lng: pathPoint.lng(),
                    }))
                  )
                );

              const totalDistance =
                result.routes[0].legs.reduce(
                  (total, leg) =>
                    total + (leg.distance?.value || 0),
                  0
                );

              const totalDuration =
                result.routes[0].legs.reduce(
                  (total, leg) =>
                    total + (leg.duration?.value || 0),
                  0
                );

              loadedSegments.push({
                id: `edit-google-${index}`,
                type:
                  to.routeMode === "walking"
                    ? "trail"
                    : "road",

                from,
                to,
                directions: result,
                routePath,
                distanceValue: totalDistance,
                durationValue: totalDuration,
              });
            } catch (directionsError) {
              console.error(
                `Google route failed between points ${index - 1
                } and ${index}`,
                directionsError
              );

              /*
               * Do not silently replace a failed Google road route
               * with a straight line because that hides the actual error.
               */
              toast.error(
                `Unable to load the saved ${to.routeMode === "walking"
                  ? "walking"
                  : "driving"
                } route.`
              );
            }
          } else {
            const routePath = [
              {
                lat: from.lat,
                lng: from.lng,
              },
              {
                lat: to.lat,
                lng: to.lng,
              },
            ];

            const distanceValue =
              window.google.maps.geometry.spherical
                .computeDistanceBetween(
                  new window.google.maps.LatLng(
                    from.lat,
                    from.lng
                  ),
                  new window.google.maps.LatLng(
                    to.lat,
                    to.lng
                  )
                );

            loadedSegments.push({
              id: `edit-manual-${index}`,
              type: "straight",
              from,
              to,
              routePath,
              distanceValue,
              durationValue: distanceValue / 1.4,
            });
          }
        }

        if (cancelled) return;

        setSegments(loadedSegments);

        const loadedMilestones = (
          challengeData.milestoneDetails || []
        ).map((milestone) => ({
          id: milestone.id || uuidv4(),
          lat: Number(milestone.latitude),
          lng: Number(milestone.longitude),
          name: milestone.title,
          address: milestone.title,
          description: milestone.description || "",
          milestoneRewardPoints:
            milestone.milestoneRewardPoints || 0,
          image: milestone.imageUrl || null,
          preview: milestone.imageUrl || "",
          segmentId: null,
        }));

        setMilestones(loadedMilestones);

        const bounds =
          new window.google.maps.LatLngBounds();

        allRoutePoints.forEach((routePoint) => {
          bounds.extend({
            lat: routePoint.lat,
            lng: routePoint.lng,
          });
        });

        loadedSegments.forEach((segment) => {
          segment.routePath?.forEach((pathPoint) => {
            bounds.extend(pathPoint);
          });
        });

        loadedMilestones.forEach((milestone) => {
          bounds.extend({
            lat: milestone.lat,
            lng: milestone.lng,
          });
        });

        if (!bounds.isEmpty()) {
          map.fitBounds(bounds);
        }
      } catch (error) {
        console.error(
          "Failed to load route for editing:",
          error
        );

        toast.error("Unable to load the saved route.");
      }
    };

    loadEditRoute();

    return () => {
      cancelled = true;
    };
  }, [map, challengeData]);

  const getChallengeDetails = async () => {
    try {
      const res = await apiGet(`/admin/challenges-Details/${id}`);

      const data = res?.data || res;

      setFormData({
        challengesName: data?.challengeName || "",
        shortDescription: data?.shortDescription || "",
        challengeOverview: data?.challengeOverview || "",
        startPoint: data?.startPoint || "",
        endPoint: data?.endPoint || "",
        challengePrice: data?.challengePrice?.replace("$", "") || "",
        startDate: data?.startDate
          ? data.startDate.split("T")[0]
          : "",
        endDate: data?.endDate
          ? data.endDate.split("T")[0]
          : "",
        categoryId: data?.categoryId || "",
        status: data?.status,
        thumbnailPreview: data.thumbnailImage,
      });

      const totalDistanceKm = Number(data?.totalDistance) || 0;
      const durationMinutes = Number(data?.timeInMinutes) || 0;
      const durationSec = durationMinutes * 60;
      const hours = Math.floor(durationMinutes / 60);
      const minutes = Math.round(durationMinutes % 60);

      setRouteStats({
        distanceKm: totalDistanceKm,
        duration: durationMinutes > 0
          ? (hours > 0 ? `${hours}h ${minutes}m` : `${minutes} min`)
          : "--",
        durationSec,
      });

      setChallengeData(data);

    } catch (err) {
      console.error(err);
    }
  };

  const getCategories = async () => {
    try {
      const res = await apiGet("/admin/challenge-categories");

      const data = res?.data || [];

      setCategories(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getPlaceName = (placeId) => {
    return new Promise((resolve, reject) => {
      const service =
        new window.google.maps.places.PlacesService(
          document.createElement("div")
        );

      service.getDetails(
        {
          placeId,
          fields: ["name"],
        },
        (place, status) => {
          if (
            status ===
            window.google.maps.places.PlacesServiceStatus.OK
          ) {
            resolve(place.name);
          } else {
            reject(status);
          }
        }
      );
    });
  };

  const handleBack = () => {
    navigate("/missions");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleThumbnailChange = (e) => {
    const file = e.target.files?.[0];

    setFormData((prev) => ({
      ...prev,
      thumbnailImage: file,
      thumbnailPreview: URL.createObjectURL(file),
    }));

    if (errors.thumbnailImage) {
      setErrors((prev) => ({
        ...prev,
        thumbnailImage: "",
      }));
    }
  };

  const handleMilestoneChange = (e) => {
    setMilestoneForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleMilestoneImage = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setMilestoneForm((prev) => ({
      ...prev,
      image: file,
      preview: URL.createObjectURL(file),
    }));

  };

  const handleMapClick = async (e) => {
    setSearchCircleCenter(null);

    if (isMilestoneMode) return;

    // Prevent multiple async map clicks
    if (routeClickLockRef.current) return;

    routeClickLockRef.current = true;

    try {
      const clickedPoint = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };

      const location = await reverseGeocode(
        clickedPoint.lat,
        clickedPoint.lng
      );

      const placeName = await getPlaceName(location.placeId);

      const newPoint = {
        id: uuidv4(),
        ...clickedPoint,
        address: location.address,
        name: placeName,
        placeId: location.placeId,
        segmentType: routeType,
      };

      // Always use the latest points
      const currentPoints = pointsRef.current;
      const previousPoint =
        currentPoints[currentPoints.length - 1];

      const updatedPoints = [
        ...currentPoints,
        newPoint,
      ];

      pointsRef.current = updatedPoints;
      setPoints(updatedPoints);

      if (previousPoint) {
        await createRoute(previousPoint, newPoint);
      }
    } catch (error) {
      console.error("Failed to add route point:", error);
    } finally {
      routeClickLockRef.current = false;
    }
  };

  const MAX_CHECKPOINT_GAP_METERS = 200;

  const STRAIGHT_SPEED_METERS_PER_SECOND = 1.4;

  const checkCheckpointRouteGap = (result, from, to) => {
    const leg = result?.routes?.[0]?.legs?.[0];

    if (!leg) {
      return {
        isConnected: false,
        startGap: Infinity,
        endGap: Infinity,
        routeStartPoint: null,
        routeEndPoint: null,
      };
    }

    const checkpointStart = new window.google.maps.LatLng(
      from.lat,
      from.lng
    );

    const checkpointEnd = new window.google.maps.LatLng(
      to.lat,
      to.lng
    );

    // Google may move/snap the route endpoints to a nearby road.
    const googleRouteStart = leg.start_location;
    const googleRouteEnd = leg.end_location;

    const startGap =
      window.google.maps.geometry.spherical.computeDistanceBetween(
        checkpointStart,
        googleRouteStart
      );

    const endGap =
      window.google.maps.geometry.spherical.computeDistanceBetween(
        checkpointEnd,
        googleRouteEnd
      );

    return {
      startGap,
      endGap,

      routeStartPoint: {
        lat: googleRouteStart.lat(),
        lng: googleRouteStart.lng(),
      },

      routeEndPoint: {
        lat: googleRouteEnd.lat(),
        lng: googleRouteEnd.lng(),
      },

      isConnected:
        startGap <= MAX_CHECKPOINT_GAP_METERS &&
        endGap <= MAX_CHECKPOINT_GAP_METERS,
    };
  };

  const createRoute = async (from, to) => {
    if (!window.google || !from || !to) return;

    const selectedType = to?.segmentType || routeType;

    const straightDistance =
      window.google.maps.geometry.spherical.computeDistanceBetween(
        new window.google.maps.LatLng(from.lat, from.lng),
        new window.google.maps.LatLng(to.lat, to.lng)
      );

    const requestDirections = (travelMode) => {
      return new Promise((resolve) => {
        const directionsService =
          new window.google.maps.DirectionsService();

        directionsService.route(
          {
            origin: {
              lat: from.lat,
              lng: from.lng,
            },
            destination: {
              lat: to.lat,
              lng: to.lng,
            },
            travelMode,
          },
          (result, status) => {
            if (
              status ===
              window.google.maps.DirectionsStatus.OK &&
              result?.routes?.[0]?.legs?.[0]
            ) {
              resolve(result);
            } else {
              resolve(null);
            }
          }
        );
      });
    };

    const updateRouteStats = (
      distanceValue,
      durationValue
    ) => {
      setRouteStats((prev) => {
        const previousDistance =
          Number(prev.distanceKm) || 0;

        const previousDuration =
          Number(prev.durationSec) || 0;

        const totalDistance =
          previousDistance * 1000 + distanceValue;

        const totalDuration =
          previousDuration + durationValue;

        const hours = Math.floor(totalDuration / 3600);

        const minutes = Math.floor(
          (totalDuration % 3600) / 60
        );

        return {
          ...prev,
          distanceKm: totalDistance / 1000,
          duration:
            hours > 0
              ? `${hours}h ${minutes}m`
              : `${minutes} min`,
          durationSec: totalDuration,
        };
      });
    };

    const updateCheckpointSegmentType = (type) => {
      setPoints((prev) => {
        const updatedPoints = prev.map((point) =>
          point.id === to.id
            ? {
              ...point,
              segmentType: type,
            }
            : point
        );

        // Keep pointsRef synchronized with React state.
        pointsRef.current = updatedPoints;

        return updatedPoints;
      });
    };

    /*
     * Complete straight-line fallback:
     *
     * checkpoint A ---------------- checkpoint B
     */
    const saveStraightRoute = () => {
      const durationValue =
        straightDistance /
        STRAIGHT_SPEED_METERS_PER_SECOND;

      setSegments((prev) => [
        ...prev,
        {
          id: uuidv4(),
          from,
          to,
          type: "straight",

          routePath: [
            {
              lat: from.lat,
              lng: from.lng,
            },
            {
              lat: to.lat,
              lng: to.lng,
            },
          ],

          distanceValue: straightDistance,
          durationValue,
        },
      ]);

      updateCheckpointSegmentType("straight");

      updateRouteStats(
        straightDistance,
        durationValue
      );
    };

    const saveGoogleRoute = (
      result,
      type,
      gapCheck
    ) => {
      const leg = result.routes[0].legs[0];

      const googleRoutePath = result.routes[0].legs.flatMap((routeLeg) =>
        routeLeg.steps.flatMap((step) =>
          step.path.map((point) => ({
            lat: point.lat(),
            lng: point.lng(),
          }))
        )
      );

      const fromPoint = {
        lat: from.lat,
        lng: from.lng,
      };

      const toPoint = {
        lat: to.lat,
        lng: to.lng,
      };

      const startConnectorPath =
        gapCheck.startGap > 0.5
          ? [
            fromPoint,
            gapCheck.routeStartPoint,
          ]
          : [];

      const endConnectorPath =
        gapCheck.endGap > 0.5
          ? [
            gapCheck.routeEndPoint,
            toPoint,
          ]
          : [];

      const routePath = [
        fromPoint,
        ...googleRoutePath,
        toPoint,
      ];

      const connectorDistance =
        gapCheck.startGap + gapCheck.endGap;

      const connectorDuration =
        connectorDistance /
        STRAIGHT_SPEED_METERS_PER_SECOND;

      const totalDistance =
        leg.distance.value + connectorDistance;

      const totalDuration =
        leg.duration.value + connectorDuration;

      setSegments((prev) => [
        ...prev,
        {
          id: uuidv4(),
          from,
          to,
          type,

          directions: result,
          routePath,

          // New straight connector paths
          startConnectorPath,
          endConnectorPath,

          // Google distance + connector distances
          distanceValue: totalDistance,
          durationValue: totalDuration,
        },
      ]);

      updateCheckpointSegmentType(type);

      updateRouteStats(
        totalDistance,
        totalDuration
      );
    };

    /*
     * User manually selected Straight.
     */
    if (selectedType === "straight") {
      saveStraightRoute();
      return;
    }

    /*
     * User selected Trail:
     *
     * Trail → Straight fallback
     */
    if (selectedType === "trail") {
      const trailResult = await requestDirections(
        window.google.maps.TravelMode.WALKING
      );

      if (trailResult) {
        const trailGapCheck =
          checkCheckpointRouteGap(
            trailResult,
            from,
            to
          );

        if (trailGapCheck.isConnected) {
          saveGoogleRoute(
            trailResult,
            "trail",
            trailGapCheck
          );

          return;
        }
      }

      // No nearby walking/trail route.
      saveStraightRoute();
      return;
    }

    /*
     * User selected Road:
     *
     * Road → Trail → Straight fallback
     */
    const roadResult = await requestDirections(
      window.google.maps.TravelMode.DRIVING
    );

    if (roadResult) {
      const roadGapCheck =
        checkCheckpointRouteGap(
          roadResult,
          from,
          to
        );

      if (roadGapCheck.isConnected) {
        saveGoogleRoute(
          roadResult,
          "road",
          roadGapCheck
        );

        return;
      }
    }

    /*
     * Road is unavailable or not close enough.
     * Try walking/trail.
     */
    const trailResult = await requestDirections(
      window.google.maps.TravelMode.WALKING
    );

    if (trailResult) {
      const trailGapCheck =
        checkCheckpointRouteGap(
          trailResult,
          from,
          to
        );

      if (trailGapCheck.isConnected) {
        saveGoogleRoute(
          trailResult,
          "trail",
          trailGapCheck
        );

        return;
      }
    }

    /*
     * Neither road nor trail is available near both
     * checkpoints.
     */
    saveStraightRoute();
  };


  const reverseGeocode = (lat, lng) => {
    return new Promise((resolve, reject) => {
      const geocoder = new window.google.maps.Geocoder();


      geocoder.geocode(
        {
          location: { lat, lng },
        },
        (results, status) => {
          if (
            status === "OK" &&
            results &&
            results.length > 0
          ) {
            resolve({ address: results[0].formatted_address, placeId: results[0].place_id, });


          } else {
            reject(
              new Error(
                `Geocoder failed due to: ${status}`
              )
            );
          }
        }
      );
    });
  };


  const handlePlaceChanged = () => {
    const place = autocomplete?.getPlace();


    if (!place?.geometry?.location || !mapRef.current) return;

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(15);

    setSearchCircleCenter({ lat, lng });
  };

  // const handleMilestonePlaceChanged = () => {
  //   const place = milestoneAutocomplete?.getPlace();

  //   if (!place?.geometry?.location) return;

  //   const lat = place.geometry.location.lat();
  //   const lng = place.geometry.location.lng();

  //   setMilestoneForm((prev) => ({
  //     ...prev,
  //     location: place.formatted_address || place.name,
  //     lat,
  //     lng,
  //   }));

  // };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) {
      return;
    }

    setPoints((items) => {
      const oldIndex = items.findIndex(
        (item) => item.id === active.id
      );

      const newIndex = items.findIndex(
        (item) => item.id === over.id
      );

      return arrayMove(
        items,
        oldIndex,
        newIndex
      );
    });
  };

  const CONNECTOR_POINT_PREFIX = "__ROUTE_CONNECTOR__";

  const buildRoutePointsPayload = () => {
    if (!segments.length) {
      return points.map((point, index) => {
        const base = {
          title: point.name,
          latitude: Number(point.lat),
          longitude: Number(point.lng),
        };

        if (index === 0) {
          return base;
        }

        const segmentType =
          point.segmentType || routeType;

        if (segmentType === "straight") {
          return {
            ...base,
            routeSource: "MANUAL",
            // routeMode: "straight",
          };
        }

        return {
          ...base,
          routeSource: "GOOGLE",
          routeMode:
            segmentType === "trail"
              ? "walking"
              : "driving",
        };
      });
    }

    const routePointsPayload = [];

    const addPoint = (point) => {
      if (
        point?.latitude == null ||
        point?.longitude == null
      ) {
        return;
      }

      const lastPoint =
        routePointsPayload[
        routePointsPayload.length - 1
        ];

      const isDuplicate =
        lastPoint &&
        Math.abs(
          Number(lastPoint.latitude) -
          Number(point.latitude)
        ) < 0.0000001 &&
        Math.abs(
          Number(lastPoint.longitude) -
          Number(point.longitude)
        ) < 0.0000001;

      if (!isDuplicate) {
        routePointsPayload.push(point);
      }
    };

    segments.forEach((segment, segmentIndex) => {
      const fromPoint = {
        title:
          segment.from?.name ||
          segment.from?.address ||
          `Route Point ${segmentIndex + 1}`,
        latitude: Number(segment.from.lat),
        longitude: Number(segment.from.lng),
      };

      if (routePointsPayload.length === 0) {
        addPoint(fromPoint);
      }

      if (segment.type === "straight") {
        addPoint({
          title:
            segment.to?.name ||
            segment.to?.address ||
            `Route Point ${segmentIndex + 2}`,
          latitude: Number(segment.to.lat),
          longitude: Number(segment.to.lng),
          routeSource: "MANUAL",
        });

        return;
      }

      if (segment.type === "decoded") {
        const segmentType =
          segment.to?.segmentType || routeType;

        addPoint({
          title:
            segment.to?.name ||
            segment.to?.address ||
            `Route Point ${segmentIndex + 2}`,
          latitude: Number(segment.to.lat),
          longitude: Number(segment.to.lng),
          routeSource:
            segmentType === "straight"
              ? "MANUAL"
              : "GOOGLE",
          ...(segmentType !== "straight"
            ? {
              routeMode:
                segmentType === "trail"
                  ? "walking"
                  : "driving",
            }
            : {}),
        });

        return;
      }

      const startConnectorPoint =
        segment.startConnectorPath?.[1];

      const endConnectorPoint =
        segment.endConnectorPath?.[0];

      if (startConnectorPoint) {
        addPoint({
          title: `${CONNECTOR_POINT_PREFIX}_START_${segmentIndex}`,
          latitude: Number(
            startConnectorPoint.lat
          ),
          longitude: Number(
            startConnectorPoint.lng
          ),
          routeSource: "MANUAL",
        });
      }

      if (endConnectorPoint) {
        addPoint({
          title: `${CONNECTOR_POINT_PREFIX}_END_${segmentIndex}`,
          latitude: Number(
            endConnectorPoint.lat
          ),
          longitude: Number(
            endConnectorPoint.lng
          ),
          routeSource: "GOOGLE",
          routeMode:
            segment.type === "trail"
              ? "walking"
              : "driving",
        });
      }

      addPoint({
        title:
          segment.to?.name ||
          segment.to?.address ||
          `Route Point ${segmentIndex + 2}`,
        latitude: Number(segment.to.lat),
        longitude: Number(segment.to.lng),
        ...(endConnectorPoint
          ? { routeSource: "MANUAL" }
          : {
            routeSource: "GOOGLE",
            routeMode: segment.type === "trail" ? "walking" : "driving",
          }),
      });
    });

    return routePointsPayload;
  };



  // const buildRoutePointsPayload = () => {
  //   return points.map((point, index) => {
  //     const base = {
  //       title: point.name,
  //       latitude: Number(point.lat),
  //       longitude: Number(point.lng),
  //     };

  //     if (index === 0) {
  //       return base;
  //     }

  //     const segmentType = point.segmentType || routeType;

  //     if (segmentType === "straight") {
  //       return {
  //         ...base,
  //         routeSource: "MANUAL",
  //       };
  //     }

  //     return {
  //       ...base,
  //       routeSource: "GOOGLE",
  //       routeMode: segmentType === "trail" ? "walking" : "driving",
  //     };
  //   });
  // };

  const buildMilestonesPayload = () => {
    const milestoneImageFiles = [];

    const milestonesPayload = milestones.map((milestone) => {
      const payload = {
        title: milestone.name,
        latitude: Number(milestone.lat),
        longitude: Number(milestone.lng),
        description: milestone.description || "",
        milestoneRewardPoints: Number(milestone.milestoneRewardPoints) || 0,
      };

      if (id) {
        payload.id = Number(milestone?.id);
      }

      if (milestone.image instanceof File) {
        payload.imageIndex = milestoneImageFiles.length;
        milestoneImageFiles.push(milestone.image);
      }

      return payload;
    });

    return { milestonesPayload, milestoneImageFiles };
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.startPoint.trim()) {
      newErrors.startPoint = "Start Point is required";
    }

    if (!formData.endPoint.trim()) {
      newErrors.endPoint = "End Point is required";
    }

    if (!formData.challengesName.trim()) {
      newErrors.challengesName = "Mission Title is required";
    }

    if (!formData.shortDescription.trim()) {
      newErrors.shortDescription = "Description is required";
    }

    if (!formData.challengeOverview.trim()) {
      newErrors.challengeOverview = "Overview is required";
    }

    if (!formData.startDate) {
      newErrors.startDate = "Start Date is required";
    }

    if (!formData.endDate) {
      newErrors.endDate = "End Date is required";
    }

    if (!id && !formData.categoryId) {
      newErrors.categoryId = "Category is required";
    }

    if (!formData.challengePrice) {
      newErrors.challengePrice = "Price is required";
    } else if (isNaN(formData.challengePrice) || Number(formData.challengePrice) < 0) {
      newErrors.challengePrice = "Enter a valid price";
    }

    if (!formData.thumbnailImage && !formData.thumbnailPreview) {
      newErrors.thumbnailImage = "Thumbnail image is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (status) => {

    if (points.length < 2) {
      toast.warning("Please add at least a start and end point to the route.");
    }
    if (!validateForm()) return;
    if (!start || !end) {
      console.error("A start and end point are required before saving.");
      return;
    }

    setIsSubmitting(true);

    try {
      const form = new FormData();

      if (!id) {
        form.append("categoryId", formData.categoryId);

      }
      form.append("challengesName", formData.challengesName);
      form.append("shortDescription", formData.shortDescription);
      form.append("challengeOverview", formData.challengeOverview);
      form.append("difficultyLevel", "HARD");
      form.append("startPoint", formData.startPoint);
      form.append("endPoint", formData.endPoint);
      form.append("challengePrice", formData.challengePrice.replace("$", ""));
      form.append("maxTeamMembers", "5");
      // form.append("milestoneRewardPoints", "100");
      form.append("isPaid", "true");
      form.append("isFeatured", "true");
      form.append("startDate", formData.startDate);
      form.append("endDate", formData.endDate);
      form.append("startLatitude", Number(start?.lat));
      form.append("startLongitude", Number(start?.lng));
      form.append("endLatitude", Number(end?.lat));
      form.append("endLongitude", Number(end?.lng));
      if (formData.thumbnailImage) {
        form.append("thumbnailImage", formData.thumbnailImage);
      }

      const routePoints = buildRoutePointsPayload();
      form.append("routePoints", JSON.stringify(routePoints));

      const { milestonesPayload, milestoneImageFiles } = buildMilestonesPayload();
      form.append("milestones", JSON.stringify(milestonesPayload));
      milestoneImageFiles.forEach((file) => {
        form.append("milestoneImages", file);
      });

      form.append(
        "status",
        id ? formData.status : status
      );

      const endpoint = id
        ? `/admin/update-challenge/${id}`
        : "/admin/create-challenge";

      const response = id
        ? await apiPatch(
          endpoint,
          form,
          {},
          {
            showSuccessToast: true,
            successMessage: "Mission updated successfully",
          }
        )
        : await apiPost(
          endpoint,
          form,
          {},
          {
            showSuccessToast: true,
            successMessage: "Mission created successfully",
          }
        );

      setModalOpen(false);




      // navigate("/missions");
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCreateMissionClick = () => {
    if (id) {
      handleSubmit("ACTIVE");
      return;
    }

    const isValid = validateForm();

    if (!isValid) return;

    setModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingMilestoneId(null);

    setMilestoneForm({
      name: "",
      location: "",
      description: "",
      milestoneRewardPoints: "",
      image: null,
      preview: "",
      lat: null,
      lng: null,
    });
  };


  const findNearestSegmentId = (lat, lng) => {
    if (!window.google || lat == null || lng == null || segments.length === 0) {
      return null;
    }

    const target = new window.google.maps.LatLng(lat, lng);
    let bestId = null;
    let bestDist = Infinity;

    segments.forEach((segment) => {
      const pathPoints =
        segment.routePath && segment.routePath.length > 0
          ? segment.routePath
          : [segment.from, segment.to].filter(Boolean);

      pathPoints.forEach((p) => {
        if (!p) return;
        const dist = window.google.maps.geometry.spherical.computeDistanceBetween(
          target,
          new window.google.maps.LatLng(p.lat, p.lng)
        );
        if (dist < bestDist) {
          bestDist = dist;
          bestId = segment.id;
        }
      });
    });

    return bestId;
  };

  const handleSaveMilestone = () => {
    const segmentId = findNearestSegmentId(milestoneForm.lat, milestoneForm.lng);

    if (editingMilestone) {
      // Update existing milestone
      const updatedMilestones = milestones.map((milestone) =>
        milestone.id === editingMilestone.id
          ? {
            ...milestone,
            lat: milestoneForm.lat,
            lng: milestoneForm.lng,
            name: milestoneForm.name,
            address: milestoneForm.location,
            description: milestoneForm.description,
            milestoneRewardPoints: milestoneForm.milestoneRewardPoints,
            image: milestoneForm.image,
            preview: milestoneForm.preview,
            segmentId,
          }
          : milestone
      );

      setMilestones(updatedMilestones);

    } else {
      setMilestones((prev) => [
        ...prev,
        {
          id: uuidv4(),
          lat: milestoneForm.lat,
          lng: milestoneForm.lng,
          name: milestoneForm.name,
          address: milestoneForm.location,
          description: milestoneForm.description,
          milestoneRewardPoints: milestoneForm.milestoneRewardPoints,
          image: milestoneForm.image,
          preview: milestoneForm.preview,
          segmentId,
        },
      ]);
    }

    closeModal();
    setEditingMilestone(null);
  };

  const handleRouteTypeChange = (type) => {
    // if (points.length > 0) return;
    setRouteType(type);
  };

  const mapRef = useRef(null);

  const handleMapLoad = (mapInstance) => {
    mapRef.current = mapInstance;
    setMap(mapInstance);

    if (!id) {
      mapInstance.setZoom(3);
      mapInstance.panTo(center);
    }
  };

  const handleEditMilestone = (milestone) => {
    setEditingMilestone(milestone);

    setMilestoneForm({
      name: milestone.name || "",
      location: milestone.address || "",
      description: milestone.description || "",
      milestoneRewardPoints: milestone.milestoneRewardPoints || "",
      image: milestone.image || null,
      preview: milestone.preview || milestone.image || "",
      lat: milestone.lat,
      lng: milestone.lng,
    });

    setIsModalOpen(true);
  };

  const handleDeleteMilestone = (id) => {
    setMilestones((prev) =>
      prev.filter((milestone) => milestone.id !== id)
    );

  };

  const handleRouteClick = async (event, segment) => {
    if (!isMilestoneMode || !segment?.routePath?.length) return;

    try {
      const clickedLocation = point([
        event.latLng.lng(),
        event.latLng.lat(),
      ]);

      const routeLine = lineString(
        segment.routePath.map((routePoint) => [
          routePoint.lng,
          routePoint.lat,
        ])
      );

      // Find exact nearest position on the route
      const snappedPoint = nearestPointOnLine(
        routeLine,
        clickedLocation,
        {
          units: "meters",
        }
      );

      const [snappedLng, snappedLat] =
        snappedPoint.geometry.coordinates;

      const location = await reverseGeocode(
        snappedLat,
        snappedLng
      );

      let placeName = location.address;

      try {
        placeName = await getPlaceName(location.placeId);
      } catch (error) {
        console.warn("Place name not available");
      }

      setMilestoneForm((previous) => ({
        ...previous,
        lat: snappedLat,
        lng: snappedLng,
        location: location.address,
        // name: placeName,
      }));

      setIsModalOpen(true);
    } catch (error) {
      console.error("Failed to create milestone:", error);
    }
  };

  const handleUndo = () => {
    setSegments(prev => {
      const lastSegment = prev[prev.length - 1];
      if (lastSegment) {
        setRouteStats(stats => {
          const totalDistance = stats.distanceKm * 1000 - (lastSegment.distanceValue || 0);
          const totalDuration = stats.durationSec - (lastSegment.durationValue || 0);
          const hours = Math.floor(totalDuration / 3600);
          const minutes = Math.floor((totalDuration % 3600) / 60);
          return {
            distanceKm: Math.max(0, totalDistance / 1000),
            duration: totalDuration > 0 ? (hours > 0 ? `${hours}h ${minutes}m` : `${minutes} min`) : "--",
            durationSec: Math.max(0, totalDuration),
          };
        });

        // Remove any milestones that were placed on the leg being undone.
        setMilestones(prevMilestones =>
          prevMilestones.filter(m => m.segmentId !== lastSegment.id)
        );
      }
      return prev.slice(0, -1);
    });

    if (points.length <= 2) {
      setIsMilestoneMode(false);
    }

    setPoints(prev => {
      const updatedPoints = prev.slice(0, -1);
      // setFormData(f => ({
      //   ...f,
      //   startPoint: updatedPoints.length > 0 ? updatedPoints[0]?.address : "",
      //   endPoint: updatedPoints.length > 1 ? updatedPoints[updatedPoints.length - 1]?.address : "",
      // }));
      return updatedPoints;
    });
  };

  return (
    <div className="main-card">


      {isSubmitting && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(128, 128, 128, 0.6)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "56px",
              height: "56px",
              border: "6px solid #e0e0e0",
              borderTop: "6px solid #2563eb",
              borderRadius: "50%",
              animation: "spin 0.9s linear infinite",
            }}
          />
          <style>
            {`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}
          </style>
        </div>
      )}


      <div className="content-area">

        {/* Top Bar */}
        <div className="action-bar">
          <div className="left-actions">
            <button onClick={handleBack} className="back-btn">
              <img src={rightarrow} alt="" />
              Back
            </button>
            <h2 className="campaign-title">{id ? "Edit Mission" : "Create New Mission"}</h2>
          </div>



          <div className="d-flex gap-3">
            {!id && (<button className="btn-outline" onClick={() => handleSubmit("draft")}>Save Draft</button>)}
            <button
              className="marketing__create-btn"
              onClick={handleCreateMissionClick}
            >
              {id ? "Update Mission" : "Create Mission"}
            </button>
          </div>
        </div>

        <div className="mission-layout">

          {/* RIGHT */}
          <div className="mission-preview">
            <div className="map-box">
              <div className="row mission-form p-2">
                <div className="col-md-3">
                  <label>Start Point</label>
                  <input type="text" name="startPoint" onChange={handleChange} value={formData.startPoint || ""} className="mb-0" />
                  {errors.startPoint && (
                    <small className="text-danger">{errors.startPoint}</small>
                  )}
                </div>
                <div className="col-md-3">
                  <label>End Point</label>
                  <input type="text" name="endPoint" onChange={handleChange} value={formData.endPoint || ""} className="mb-0" />
                  {errors.endPoint && (
                    <small className="text-danger">{errors.endPoint}</small>
                  )}
                </div>

                <div className="route-type-selector mission-form col-md-3">
                  <label>Route Type</label>
                  <div className="d-flex gap-2 w-100">
                    <button
                      className={routeType === "road" ? "marketing__create-btn active" : ""}
                      onClick={() => handleRouteTypeChange("road")}
                    >
                      <FaRoad /> Road
                    </button>

                    <button
                      className={routeType === "trail" ? "marketing__create-btn active " : ""}
                      onClick={() => handleRouteTypeChange("trail")}
                    >
                      <FaWalking /> Trail
                    </button>

                    <button
                      className={routeType === "straight" ? "marketing__create-btn active" : ""}
                      onClick={() => handleRouteTypeChange("straight")}
                    >
                      <FaLine /> Straight
                    </button>
                  </div>


                </div>

                <div className="col-md-2">
                  <label></label>
                  <div className="d-flex gap-2 w-100">
                    <button
                      className="btn btn-info"
                      onClick={() => {
                        setPoints([]); setSegments([]); setRouteStats({
                          distanceKm: 0,
                          durationHours: 0,
                        }); setMilestones([]); setFormData(prev => ({ ...prev, startPoint: "", endPoint: "" })); setIsMilestoneMode(false)
                      }}
                    >
                      Reset
                    </button>

                    <button
                      className="btn btn-warning"
                      onClick={handleUndo}
                    >
                      Undo
                    </button>

                  </div>
                </div>
                <div className="col-md-1 d-flex align-items-end">
                  <div className="form-check form-switch mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={isMilestoneMode}
                      onChange={(e) => setIsMilestoneMode(e.target.checked)} id="flexSwitchCheckDefault"
                      disabled={points.length < 2}
                    />
                    <label
                      className="form-check-label ms-0"
                      htmlFor="flexSwitchCheckDefault"
                    >
                      Add Milestone
                    </label>
                  </div>
                </div>
              </div>


              <div style={{ position: "relative" }}>

                <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={["places", "geometry"]}>
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 1000,
                      width: "400px",
                    }}
                  >
                    <Autocomplete
                      onLoad={(ac) => setAutocomplete(ac)}
                      onPlaceChanged={handlePlaceChanged}
                    >
                      <div style={{ position: "relative", zIndex: 11 }}>
                        <FaSearch style={{
                          position: "absolute",
                          left: "35px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#666",
                        }} />
                        <input
                          type="text"
                          placeholder="Search location..."
                          style={{
                            width: "100%",
                            padding: "12px 15px 12px 35px", margin: "22px 22px",
                            borderRadius: "24px",
                          }}
                          className="border-0"
                        />
                      </div>

                    </Autocomplete>
                  </div>
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    // center={center}
                    // zoom={12}
                    onClick={handleMapClick}
                    options={{
                      draggableCursor: "crosshair",
                      draggingCursor: "crosshair",
                      clickableIcons: false,
                    }}
                    onLoad={handleMapLoad}
                    onRightClick={handleUndo}
                  >
                    {!isMilestoneMode && points.map((point, index) => (
                      <Marker
                        key={index}
                        position={point}
                        label={`${index + 1}`}
                      />
                    ))}
                    {milestones.map((milestone) => (
                      <Marker
                        key={milestone.id}
                        position={{ lat: milestone.lat, lng: milestone.lng }}
                        icon={{
                          url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                        }}
                        title={milestone.name}
                      />
                    ))}
                    {segments.map((segment) =>
                      segment.type === "straight" ? (
                        <Polyline
                          key={segment.id}
                          path={segment.routePath}
                          options={{
                            strokeColor: "#2563eb",
                            strokeOpacity: 1,
                            strokeWeight: 6,
                            // Turf's nearestPointOnLine follows the earth's
                            // surface. Draw the two-point straight route with
                            // the same geodesic model so the snapped milestone
                            // stays exactly on the visible line at every zoom.
                            geodesic: true,
                            clickable: true,
                            zIndex: 10,
                          }}
                          onClick={(event) =>
                            handleRouteClick(event, segment)
                          }
                        />
                      ) : segment.type === "decoded" ? (
                        <Polyline
                          key={segment.id}
                          path={segment.routePath}
                          options={{
                            strokeColor: "#2563eb",
                            strokeWeight: 6,
                            clickable: true,
                          }}
                          onClick={(event) =>
                            handleRouteClick(event, segment)
                          }
                        />
                      ) : (
                        <Polyline
                          path={segment.routePath}
                          options={{
                            strokeColor: "#2563eb",
                            strokeOpacity: 1,
                            strokeWeight: 6,
                            clickable: true,
                            zIndex: 10,
                          }}
                          onClick={(event) =>
                            handleRouteClick(event, segment)
                          }
                        />
                      )
                    )}

                    {/* {searchCircleCenter && (
                      <Circle
                        center={searchCircleCenter}
                        radius={200}
                        options={{
                          fillColor: "#007BFF",
                          fillOpacity: 0.3,
                          strokeColor: "#007BFF",
                          strokeOpacity: 0.8,
                          strokeWeight: 2,
                          clickable: false,
                          draggable: false,
                          editable: false,
                        }}
                      />
                    )} */}

                  </GoogleMap>

                  {isModalOpen && (
                    <div className="custom-modal-overlay">
                      <div className="custom-modal-content">

                        <div className="custom-modal-header">
                          <h2>Add Milestone</h2>
                          <button className="close-modal-btn" onClick={closeModal}>×</button>
                        </div>
                        <form className="custom-modal-form" onSubmit={(e) => {
                          e.preventDefault();
                          handleSaveMilestone();
                        }}>

                          <div className="form-group-full">
                            <label>Milestone Name *</label>
                            <input
                              type="text"
                              name="name"
                              value={milestoneForm.name}
                              onChange={handleMilestoneChange}
                              placeholder="Historic Building"
                              required
                            />
                          </div>

                          {/* <div className="form-group-full">
                            <label>Search Location *</label>
                            <Autocomplete
                              onLoad={(ac) => { setMilestoneAutocomplete(ac) }}
                              onPlaceChanged={() => {
                                handleMilestonePlaceChanged();
                              }}
                            >
                              <input
                                type="text"
                                name="location"
                                value={milestoneForm.location}
                                onChange={handleMilestoneChange}
                                placeholder="Search milestone location"
                                required
                              />
                            </Autocomplete>
                          </div> */}

                          <div className="form-group-full">
                            <label>Description</label>
                            <textarea
                              rows="3"
                              name="description"
                              value={milestoneForm.description}
                              onChange={handleMilestoneChange}
                              placeholder="Visit the historic building and take a photo..."
                              required
                            />
                          </div>

                          <div className="form-group-full">
                            <label>Points / Reward</label>
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 60px",
                                gap: "0",
                              }}
                            >
                              <input
                                type="number"
                                name="milestoneRewardPoints"
                                value={milestoneForm.milestoneRewardPoints}
                                onChange={handleMilestoneChange}
                                placeholder="100"
                              />

                              <input
                                type="text"
                                value="XP"
                                readOnly
                                style={{
                                  textAlign: "center",
                                  background: "#f8f8f8",
                                  cursor: "default",
                                }}
                              />
                            </div>
                          </div>

                          <div className="form-group-full">
                            <label>Image (Optional)</label>

                            <div
                              style={{
                                display: "flex",
                                gap: "12px",
                                alignItems: "center",
                              }}
                            >
                              {milestoneForm.preview && (
                                <img
                                  src={milestoneForm.preview}
                                  alt=""
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                    border: "1px solid #e5e7eb",
                                  }}
                                />
                              )}

                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleMilestoneImage}
                              />
                            </div>
                          </div>

                          <div className="custom-modal-footer">
                            <button
                              type="button"
                              className="btn-modal-draft"
                              onClick={closeModal}
                            >
                              Cancel
                            </button>

                            <button
                              type="submit"
                              className="btn-modal-send"
                            >
                              Save Milestone
                            </button>
                          </div>

                        </form>
                      </div>
                    </div>
                  )}
                </LoadScript>
              </div>


            </div>

            <br />
            <div className="map-box p-3">
              <div className="stats-grid">
                {/* Box 1 */}
                <div className="stat-box">
                  <div className="stat-header d-flex justify-content-between align-items-center">
                    <div>
                      <FaRoad />
                      <span className="fs-6 ms-2">Distance</span>
                    </div>

                    <div className="btn-group btn-group-sm" role="group">
                      <input
                        type="radio"
                        className="btn-check"
                        name="distanceUnit"
                        id="km"
                        checked={distanceUnit === "km"}
                        onChange={() => setDistanceUnit("km")}
                      />
                      <label className="btn btn-outline-primary" htmlFor="km">
                        KM
                      </label>

                      <input
                        type="radio"
                        className="btn-check"
                        name="distanceUnit"
                        id="mi"
                        checked={distanceUnit === "mi"}
                        onChange={() => setDistanceUnit("mi")}
                      />
                      <label className="btn btn-outline-primary" htmlFor="mi">
                        MI
                      </label>
                    </div>
                  </div>

                  <div className="stat-value">
                    {displayDistance}
                  </div>
                </div>

                {/* Box 2 */}
                <div className="stat-box">
                  <div className="stat-header">
                    <FaStopwatch20 />
                    <span className="fs-6">Duration</span>
                  </div>
                  <div className="stat-value">{routeStats.duration || "--"}</div>
                </div>

                {/* Box 3 */}
                <div className="stat-box">
                  <div className="stat-header">
                    <FaFlag />
                    <span className="fs-6">Milestones</span>
                  </div>
                  <div className="stat-value">{Math.max(milestones.length, 0)}</div>
                </div>

              </div>


            </div>
            <div className="map-box p-3">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h2 className="campaign-title">
                    Milestones ({Math.max(milestones.length, 0)})
                  </h2>
                  <p className="text-muted mt-1">
                    Drag to reorder milestones
                  </p>
                </div>

                <button className="btn-outline" onClick={() => setIsModalOpen(true)}>
                  <FaPlus /> Add Milestone
                </button>
              </div>

              <div className="milestones-wrapper">
                <DndContext
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <SortableContext
                    items={points.map((p) => p.id)}
                    strategy={horizontalListSortingStrategy}
                  >
                    <div className="milestones-scroll">
                      {milestones.map((point, index) => (
                        <MilestoneCard
                          key={point.id}
                          point={point}
                          index={index}
                          totalPoints={points.length}
                          onEdit={handleEditMilestone}
                          onDelete={handleDeleteMilestone}
                        />
                      ))}
                    </div>
                  </SortableContext>
                </DndContext>
              </div>

            </div>
          </div>

          {/* LEFT */}
          <div className="mission-form">
            <div className="mt-3">
              <label>Mission Title</label>
              <input type="text" name="challengesName" onChange={handleChange} value={formData.challengesName} className="mb-0" />
              {errors.challengesName && (
                <small className="text-danger">{errors.challengesName}</small>
              )}
            </div>

            <div className="mt-3">
              <label>Description</label>
              <textarea name="shortDescription" onChange={handleChange} value={formData.shortDescription} className="mb-0" />
              {errors.shortDescription && (
                <small className="text-danger">{errors.shortDescription}</small>
              )}

            </div>

            <div className="mt-3">
              <label>Overview</label>
              <textarea name="challengeOverview" onChange={handleChange} value={formData.challengeOverview} className="mb-0" />
              {errors.challengeOverview && (
                <small className="text-danger">{errors.challengeOverview}</small>
              )}
            </div>


            <div className="row mt-3">
              <div className="col-md-6">
                <label>Start Date</label>
                <input type="date" name="startDate" onChange={handleChange} value={formData.startDate} className="mb-0" min={today} />
                {errors.startDate && (
                  <small className="text-danger">{errors.startDate}</small>
                )}
              </div>

              <div className="col-md-5">
                <label>End Date</label>
                <input type="date" name="endDate" onChange={handleChange} value={formData.endDate} className="mb-0" min={formData.startDate || today} />
                {errors.endDate && (
                  <small className="text-danger">{errors.endDate}</small>
                )}
              </div>

            </div>

            <div className="row mt-3">
              {!id && (
                <div className="col-md-6">
                  <label>Category</label>
                  <select
                    name="categoryId"
                    value={formData.categoryId}
                    onChange={handleChange}
                    className="mb-0"

                  >
                    <option value="">Select Category</option>

                    {categories.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                  {errors.categoryId && (
                    <small className="text-danger">{errors.categoryId}</small>
                  )}
                </div>
              )}
              <div className="col-md-5">
                <label>Price ($)</label>
                <input type="text" name="challengePrice" onChange={handleChange} value={formData.challengePrice} className="mb-0" />
                {errors.challengePrice && (
                  <small className="text-danger">{errors.challengePrice}</small>
                )}
              </div>

              {id && (
                <div className="col-md-6">
                  <label>Status</label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    className="mb-0"
                  >
                    <option value="" disabled>Select Status</option>
                    <option value="draft">Draft</option>
                    <option value="ACTIVE">Active</option>
                  </select>

                </div>
              )}

            </div>

            <hr />

            {/* <div className="milestone-header">
              <h4>Milestone Setup</h4>
              <span style={{ color: "#666", fontSize: "14px" }}>
                Click on route to add checkpoints
              </span>
            </div> */}

            <div className="thumbnail-box">
              <p>Mission Image</p>
              <div className="upload-box large">


                <input
                  type="file"
                  accept="image/*"
                  onChange={handleThumbnailChange}
                />
                {formData.thumbnailPreview && (
                  <img
                    src={formData.thumbnailPreview}
                    alt=""
                    style={{
                      width: "80px",
                      height: "40px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "1px solid #e5e7eb",
                    }}
                  />)}
                {errors.thumbnailImage && (
                  <small className="text-danger">{errors.thumbnailImage}</small>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>

      {modalOpen && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <div className="custom-modal-header">
              <h2>Publish Mission</h2>

              <button
                type="button"
                className="close-modal-btn"
                onClick={() => setModalOpen(false)}
              // disabled={isDeleting}
              >
                ×
              </button>
            </div>

            <form
              className="custom-modal-form"
              onSubmit={(event) => {
                event.preventDefault();
                handleSubmit("ACTIVE");
              }}
            >
              <p className="fs-5">
                Are you sure you want to publish this mission?
              </p>

              <div className="custom-modal-footer">
                <button
                  type="button"
                  className="btn-modal-draft"
                  onClick={() => setModalOpen(false)}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn-modal-send"
                >
                  Publish
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
